import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

import BackgroundImage from "../../../components/backgroundImage/backgroundImage";
import MegaMenuResult from "../../../components/megaMenuResult/megaMenuResult";
import backgroundImageHelper from "../../image/backgroundImageHelper";
import KontentItemImage from "../../kontentItemImage";

const MegaMenuResultProgram = ({ data }) => (
  <MegaMenuResult
    href={data.id}
    image={(
      data.elements.hero_image?.value[0]?.system?.type === "image"
        ? (
          <div className="image-wrapper">
            <BackgroundImage
              className="w-100 h-100"
              backgroundImageStyle={{
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                ...backgroundImageHelper(data.elements.hero_image),
              }}
            />
          </div>
        )
        : (
          <KontentItemImage
            data={data.elements.hero_image}
            width={48}
            height={48}
            aspectRatio={1}
            fit="crop"
            defaultImage
          />
        )
    )}
  >
    {data.elements.headline.value}
  </MegaMenuResult>
);

export const query = graphql`
  fragment MegaMenuResultProgram on kontent_item_program {
    id
    elements {
      headline {
        value
      }
      hero_image {
        value {
          ...KontentItemImage
          ...KontentItemVideo
        }
      }
    }
  }
`;

MegaMenuResultProgram.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

export default MegaMenuResultProgram;
